import { FlashList } from "@shopify/flash-list";
import { MutableRefObject } from "react";

const useNativePreparedData = <T>(data: T, listRef: MutableRefObject<FlashList<any> | null>): T => {
	return data;
};
export default useNativePreparedData;
